// Toggle the menu open and close when on mobile
export default function menuOpen() {
    const burgerButton = document.getElementById('nav-button');
    if (burgerButton) {
        burgerButton.addEventListener('click', function () {
            const navbar = document.getElementById('navbar-default');
            console.log(navbar.classList);
            if (navbar.classList.contains('hidden')) {
                navbar.classList.add('flex');
                navbar.classList.remove('hidden');
            } else {
                navbar.classList.add('hidden');
                navbar.classList.remove('flex');
            }
        });
    }

    // Close nav dropdowns on outside click / Escape
    const closeDropdowns = (except) => document.querySelectorAll('details.nav-dropdown[open]').forEach((d) => {
        if (d !== except) d.open = false;
    });
    document.addEventListener('click', (e) => closeDropdowns(e.target.closest('details.nav-dropdown')));
    document.addEventListener('keydown', (e) => e.key === 'Escape' && closeDropdowns());

    // Desktop mice: open on hover too. The close delay bridges the gap between summary and panel.
    const canHover = window.matchMedia('(hover: hover) and (min-width: 64rem)');
    document.querySelectorAll('details.nav-dropdown').forEach((d) => {
        let closeTimer;
        d.addEventListener('mouseenter', () => {
            if (!canHover.matches) return;
            clearTimeout(closeTimer);
            closeDropdowns(d);
            d.open = true;
        });
        d.addEventListener('mouseleave', () => {
            if (canHover.matches) closeTimer = setTimeout(() => { d.open = false; }, 200);
        });
        // A mouse click on a hover-opened summary would toggle it shut; keep it open instead.
        // Keyboard activation (detail === 0) still toggles.
        d.querySelector('summary').addEventListener('click', (e) => {
            if (canHover.matches && e.detail > 0 && d.open) e.preventDefault();
        });
    });

    window.addEventListener("resize", () => {
        const isLg = document.getElementById("breakpoint-lg")?.offsetParent !== null;
        if (isLg) {
            const navbar = document.getElementById('navbar-default');
            navbar.classList.add('hidden');
        }
    });
}
